import React from 'react';
import PropTypes from 'prop-types';
import { money } from './promotionsData';
import './ApplyPromotionModal.scss';

export default function PromotionBanner({ promotion, onRemove }) {
  if (!promotion || !promotion.name) {
    return null;
  }

  const savingsText =
    promotion.savingsText ||
    money(promotion.savings || (promotion.retail && promotion.total ? promotion.retail - promotion.total : 0));

  return (
    <div id="promotionBanner" className="real-promo-banner show bg-primary-light ">
      <div>
        <strong id="promotionBannerName text-primary">{promotion.name} Applied</strong>
        <div className="promo-meta" id="promotionBannerMeta">
          {promotion.code ? `POS ${promotion.code} • ` : ''}Savings {savingsText} • Applied automatically to eligible order components
        </div>
      </div>
      <button
        type="button"
        className="remove-link btn-link"
        id="removePromotion"
        onClick={onRemove}
      >
        Remove Promotion
      </button>
    </div>
  );
}

PromotionBanner.propTypes = {
  promotion: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
    savings: PropTypes.number,
    savingsText: PropTypes.string,
    retail: PropTypes.number,
    total: PropTypes.number,
  }),
  onRemove: PropTypes.func.isRequired,
};
